// Mirrors IFSPD-mentor-api/config/year2.php — chair_criteria + rating_scale (Wave 4A).

export const YEAR2_RATING_SCALE = [
  { min: 1, max: 2, label: 'Needs significant support' },
  { min: 3, max: 4, label: 'Developing' },
  { min: 5, max: 6, label: 'Meets expectations' },
  { min: 7, max: 8, label: 'Strong' },
  { min: 9, max: 10, label: 'Exceptional' },
];

export const YEAR2_CHAIR_CRITERIA = {
  strengths: [
    'Natural Leader', 'Drives the Team', 'Brings Everyone In', 'Calm Under Pressure', 'Speaks with Clarity',
    'Owns the Outcome', 'Lifts the Energy', 'Bounces Back', 'Collaborative', 'Hands Off Cleanly',
  ],
  coaching: [
    'Initiative', 'Momentum', 'Facilitation', 'Composure', 'Communication',
    'Accountability', 'Motivation', 'Resilience', 'Team Etiquette', 'Coordination',
  ],
};

export const YEAR2_ASSESSMENT_CRITERIA_VERSION = '2026-07-06';
